export const elements = () => ({
    page: {
        display: 'flex',
    },
    noPadding: {
        padding: '0 !important'
    }
})
